import { useSelector } from 'react-redux';
import { selectCanAccessPersonalFinances } from '../../../CommonSelectors/CommonAreaSelector';

export const useCanAccessPersonalFinances = (): boolean => {
  return useSelector(selectCanAccessPersonalFinances);
};
